import { render, staticRenderFns } from "./DFPriority.vue?vue&type=template&id=e658d880&"
import script from "./DFPriority.vue?vue&type=script&lang=js&"
export * from "./DFPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports